"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popover = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var css_1 = require("@emotion/css");
var react_popper_1 = require("react-popper");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var merge_refs_1 = __importDefault(require("merge-refs"));
var useClickOutside = function (refs, callback, enabled) {
    (0, react_1.useEffect)(function () {
        var handleClick = function (event) {
            var _a;
            if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.isConnected) && (refs === null || refs === void 0 ? void 0 : refs.every(function (ref) { return !(ref === null || ref === void 0 ? void 0 : ref.contains(event.target)); }))) {
                callback();
            }
        };
        var handleKeyDown = function (event) {
            if (event.key === 'Escape') {
                callback();
            }
        };
        if (enabled) {
            document.addEventListener('click', handleClick);
            document.addEventListener('keydown', handleKeyDown);
        }
        return function () {
            document.removeEventListener('click', handleClick);
            document.removeEventListener('keydown', handleKeyDown);
        };
        // I know the callback won't change after component initialization
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, refs]);
};
var ARROW_SIZE = 15;
var POPPER_PLACEMENT = -ARROW_SIZE / 2.0;
var DEFAULT_OFFSET = ARROW_SIZE;
var arrowStyles = function (selectedTheme, variant) {
    var themedBorderColor = (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
        light: design_system_foundations_1.theme.color.neutral40,
        dark: design_system_foundations_1.darkTheme.color.blueGray50,
    });
    var borderColor = variant === 'blue' ? design_system_foundations_1.theme.color.blue90 : themedBorderColor;
    return (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    width: ", "px;\n    height: ", "px;\n    background: inherit;\n    visibility: hidden;\n\n    &::after {\n      position: absolute;\n      width: ", "px;\n      height: ", "px;\n      background: inherit;\n      visibility: visible;\n      content: \"\";\n      transform: rotate(45deg);\n      border: ", " solid ", ";\n      z-index: -1;\n    }\n  "], ["\n    position: absolute;\n    width: ", "px;\n    height: ", "px;\n    background: inherit;\n    visibility: hidden;\n\n    &::after {\n      position: absolute;\n      width: ", "px;\n      height: ", "px;\n      background: inherit;\n      visibility: visible;\n      content: \"\";\n      transform: rotate(45deg);\n      border: ", " solid ", ";\n      z-index: -1;\n    }\n  "])), ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, ARROW_SIZE, selectedTheme === 'dark' ? '0.5px' : '1px', borderColor);
};
var containerStyles = function (zIndex, width, height, selectedTheme, variant, popperPlacement) {
    if (popperPlacement === void 0) { popperPlacement = POPPER_PLACEMENT; }
    var themedBackgroundColor = (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
        light: design_system_foundations_1.theme.color.white,
        dark: design_system_foundations_1.darkTheme.color.primeBlue,
    });
    var backgroundColor = variant === 'blue' ? design_system_foundations_1.theme.color.blue90 : themedBackgroundColor;
    var themedBorderColor = (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
        light: design_system_foundations_1.theme.color.neutral40,
        dark: design_system_foundations_1.darkTheme.color.blueGray50,
    });
    var borderColor = variant === 'blue' ? design_system_foundations_1.theme.color.blue90 : themedBorderColor;
    var themedTextColor = (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: design_system_foundations_1.theme.color.black, dark: design_system_foundations_1.darkTheme.color.white });
    var textColor = variant === 'blue' ? design_system_foundations_1.theme.color.white : themedTextColor;
    return (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: ", " solid ", ";\n    background-color: ", ";\n    border-radius: 8px;\n    box-shadow: ", ";\n    color: ", ";\n    z-index: ", ";\n    ", ";\n    ", ";\n\n    &[data-popper-placement^=\"top\"] > span {\n      bottom: ", "px;\n    }\n\n    &[data-popper-placement^=\"bottom\"] > span {\n      top: ", "px;\n    }\n\n    &[data-popper-placement^=\"left\"] > span {\n      right: ", "px;\n    }\n\n    &[data-popper-placement^=\"right\"] > span {\n      left: ", "px;\n    }\n  "], ["\n    border: ", " solid ", ";\n    background-color: ", ";\n    border-radius: 8px;\n    box-shadow: ", ";\n    color: ", ";\n    z-index: ", ";\n    ", ";\n    ", ";\n\n    &[data-popper-placement^=\"top\"] > span {\n      bottom: ", "px;\n    }\n\n    &[data-popper-placement^=\"bottom\"] > span {\n      top: ", "px;\n    }\n\n    &[data-popper-placement^=\"left\"] > span {\n      right: ", "px;\n    }\n\n    &[data-popper-placement^=\"right\"] > span {\n      left: ", "px;\n    }\n  "])), selectedTheme === 'dark' ? '0.5px' : '1px', borderColor, backgroundColor, design_system_foundations_1.theme.shadow.md, textColor, zIndex, width && "width: ".concat(width, "px"), height && "height: ".concat(height, "px"), popperPlacement + 0.06 * ARROW_SIZE, popperPlacement - 0.06 * ARROW_SIZE, popperPlacement + 0.06 * ARROW_SIZE, popperPlacement - 0.06 * ARROW_SIZE);
};
var contentStyles = function (selectedTheme, variant) {
    var themedBackgroundColor = (0, design_system_foundations_1.getThemeValue)(selectedTheme, {
        light: design_system_foundations_1.theme.color.white,
        dark: design_system_foundations_1.darkTheme.color.primeBlue,
    });
    var backgroundColor = variant === 'blue' ? design_system_foundations_1.theme.color.blue90 : themedBackgroundColor;
    return (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    z-index: 1;\n    background-color: ", ";\n    border-radius: 8px;\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n  "], ["\n    position: relative;\n    z-index: 1;\n    background-color: ", ";\n    border-radius: 8px;\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n  "])), backgroundColor);
};
exports.Popover = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, className = _a.className, hasArrow = _a.hasArrow, height = _a.height, isOpen = _a.isOpen, _b = _a.offset, offset = _b === void 0 ? [0, DEFAULT_OFFSET] : _b, _c = _a.placement, placement = _c === void 0 ? 'bottom' : _c, referenceElement = _a.referenceElement, testId = _a.testId, width = _a.width, onClose = _a.onClose, userStyles = _a.style, _d = _a.zIndex, zIndex = _d === void 0 ? design_system_foundations_1.theme.zIndex.tooltip : _d, variant = _a.variant, rest = __rest(_a, ["children", "className", "hasArrow", "height", "isOpen", "offset", "placement", "referenceElement", "testId", "width", "onClose", "style", "zIndex", "variant"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var _e = (0, react_1.useState)(null), popperElement = _e[0], setPopperElement = _e[1];
    var _f = (0, react_1.useState)(null), arrowElement = _f[0], setArrowElement = _f[1];
    var resizeObserver = (0, react_1.useRef)(null);
    var _g = (0, react_popper_1.usePopper)(referenceElement, popperElement, {
        placement: placement,
        modifiers: [
            { name: 'arrow', options: { element: arrowElement } },
            { name: 'offset', options: { offset: offset } },
        ],
    }), styles = _g.styles, attributes = _g.attributes, forceUpdate = _g.forceUpdate;
    //In the future this could be a custom hook to handle the resizeObserver
    (0, react_1.useEffect)(function () {
        if (!resizeObserver.current && forceUpdate) {
            // This is a workaround for a bug in react-popper where the popper element placement is not updated when the children's width change after the first render
            // references to the issue: https://contrast.atlassian.net/browse/TS-21025
            resizeObserver.current = new ResizeObserver(function () {
                forceUpdate === null || forceUpdate === void 0 ? void 0 : forceUpdate();
            });
        }
        if (popperElement && resizeObserver.current) {
            resizeObserver.current.observe(popperElement);
        }
        return function () {
            var _a;
            if (popperElement) {
                (_a = resizeObserver.current) === null || _a === void 0 ? void 0 : _a.unobserve(popperElement);
            }
        };
    }, [popperElement, forceUpdate]);
    useClickOutside([popperElement, referenceElement], function () {
        onClose === null || onClose === void 0 ? void 0 : onClose(false);
    }, isOpen);
    var classes = (0, css_1.cx)(containerStyles(zIndex, width, height, selectedTheme, variant), className, 'ds-popover');
    return (react_1.default.createElement(react_1.default.Fragment, null, isOpen &&
        react_dom_1.default.createPortal(react_1.default.createElement("div", __assign({ "data-popper-placement": placement, className: classes, ref: (0, merge_refs_1.default)(setPopperElement, ref), style: __assign(__assign({}, styles.popper), userStyles), "data-testid": testId }, attributes.popper, rest),
            react_1.default.createElement("div", { className: contentStyles(selectedTheme, variant), "data-testid": testId && "".concat(testId, "-content") }, children),
            hasArrow && (react_1.default.createElement("span", { className: arrowStyles(selectedTheme, variant), ref: setArrowElement, "data-testid": testId && "".concat(testId, "-arrow"), style: styles.arrow }))), document.body)));
});
exports.Popover.displayName = 'Popover';
var templateObject_1, templateObject_2, templateObject_3;
